import React, { Component } from "react"
import { Affix, DatePicker, Row, Button } from "antd"
import { observer, inject } from "mobx-react"
import moment from "moment"

const RangePicker = DatePicker.RangePicker

@inject("auth") @observer
class DataHeader extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dayKey: "-1",
    }
  }

  dateChange = (dateValue, dateString) => {
    const { updateQueryMap } = this.props.store
    updateQueryMap({
      start: dateString[0],
      end: moment(dateString[1], "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD")
    })
    this.setState({
      dateValue: dateValue
    })
  }

  disabledDate = (current) => {
    return current && (current.valueOf() < new Date('2019-01-01') || current.valueOf() > new Date())
  }

  renderDayMenu = () => {
    const { createStatisticsJobs } = this.props.store
    return (
      <div className="search-month-bar">
        <Row type="flex" justify="space-between" align="middle" className="content">
          <Row type="flex" align="middle">
            <span
              style={{
                display: 'inline-block',
                lineHeight: '45px',
                marginLeft: 12
              }}
            >
              请选择查询时间：</span>
            <RangePicker
              ranges={{
                "今天": [moment(), moment()],
                "本月": [moment().startOf("month"), moment()]
              }}
              showTime
              value={this.state.dateValue}
              onChange={this.dateChange}
              disabledDate={this.disabledDate}
            />
            <Button
              type="primary"
              size="default"
              style={{ marginLeft: 20 }}
              onClick={() => createStatisticsJobs()}
            >
              开始统计任务
            </Button>
          </Row>
        </Row>
      </div>
    )
  }

  render() {
    return (
      <Affix
        className="affix-head"
        target={() => document.getElementsByClassName("salt-pagelayout")[0]} offsetTop={50}
      >
        <div className="affix-back">
          {this.renderDayMenu()}
        </div>
      </Affix>
    )
  }

}

export default DataHeader


// WEBPACK FOOTER //
// ./src/app/pages/pgs/data_statistics/container/DataHeader.js